import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FacilityObject } from '../services/facility.model';
import { FacilityService } from '../services/facility.service';

@Component({
  selector: 'app-operating-hours',
  templateUrl: './operating-hours.component.html',
  styleUrls: ['./operating-hours.component.scss']
})
export class OperatingHoursComponent implements OnInit {
  form: FormGroup;
  selectedFacility: FacilityObject;

  @Input() openingHoursVisible: boolean;
  @Input() operatingHours: string;
  @Output() openingHoursVisibleChange = new EventEmitter<any>();
  constructor(private fb: FormBuilder, private _facilityService: FacilityService) { }

  ngOnInit(): void {

    this.form = this.fb.group(
      {
        openingH: ['', Validators.required],
        openingM: ['', Validators.required],
        closingH: ['', Validators.required],
        closingM: ['', Validators.required],
      },
      {
        validator: [this.validateTime()],
      }
    );

    this.selectedFacility = this._facilityService.selectedFacility();

    let formDefaultData = {
      openingH: Number(this.selectedFacility.summary.facilityHoursStart),
      openingM: Number(this.selectedFacility.summary.facilityMinsStart),
      closingH: Number(this.selectedFacility.summary.facilityHoursEnd),
      closingM: Number(this.selectedFacility.summary.facilityMinsEnd),
    };

    this.form.patchValue(formDefaultData);
  }

  validateTime() {
    return (formGroup: FormGroup) => {
        const openingH = formGroup.controls['openingH'];
        const openingM = formGroup.controls['openingM'];
        const closingH = formGroup.controls['closingH'];
        const closingM = formGroup.controls['closingM'];
        let error = false;
        if(openingH.value > closingH.value) {
          error = true;
        } else if(openingH.value === closingH.value && openingM.value >= closingM.value) {
          error = true;
        }

        if (error) {
          openingH.setErrors({ invalid: true });
          openingM.setErrors({ invalid: true });
          closingH.setErrors({ invalid: true });
          closingM.setErrors({ invalid: true });
        } else {
          openingH.setErrors(null);
          openingM.setErrors(null);
          closingH.setErrors(null);
          closingM.setErrors(null);
        }
    };
  }

  closeDialog() {
    this.openingHoursVisible = false;
    this.openingHoursVisibleChange.emit({visible: this.openingHoursVisible, facilityHoursStart: null, facilityMinsStart: null, facilityHoursEnd: null, facilityMinsEnd: null});
  }

  close() {
    if(this.form.controls['closingH'].errors == null) {
      this.openingHoursVisible = false;
      this.openingHoursVisibleChange.emit({visible: this.openingHoursVisible, facilityHoursStart: this.form.value.openingH, facilityMinsStart: this.form.value.openingM, facilityHoursEnd: this.form.value.closingH, facilityMinsEnd: this.form.value.closingM});
      this.selectedFacility.summary.facilityHoursStart = this.form.value.openingH;
      this.selectedFacility.summary.facilityMinsStart = this.form.value.openingM;
      this.selectedFacility.summary.facilityHoursEnd = this.form.value.closingH;
      this.selectedFacility.summary.facilityMinsEnd = this.form.value.closingH == 24 ? 0 : this.form.value.closingM;
      this._facilityService.updateOperatinHours(this.selectedFacility.summary);
      let startDate = new Date();
      startDate.setHours(this.form.value.openingH);
      startDate.setMinutes(this.form.value.openingM);
  
      let closetDate = new Date();
      closetDate.setHours(this.form.value.closingH);
      closetDate.setMinutes(this.form.value.closingM);
  
      let diference = Math.abs(startDate.getTime() - closetDate.getTime())/1000/60/60;
      let h = Math.floor(diference);
      let m = (diference - Math.floor(diference))*60;
      this.operatingHours = this.getDiference(this.form.value.openingH, this.form.value.openingM, this.form.value.closingH, this.form.value.closingM)
    }

  }

  getDiference(openingH: number, openingM: number, closingH: number, closingM: number) {
    let startDate = new Date();
    startDate.setHours(openingH);
    startDate.setMinutes(openingM);

    let closetDate = new Date();
    closetDate.setHours(closingH);
    closetDate.setMinutes(closingM);

    let diference = Math.abs(startDate.getTime() - closetDate.getTime())/1000/60/60;
    let h = Math.floor(diference);
    let m = (diference - Math.floor(diference))*60;
    return h < 10 ? '0' + h.toString() : h.toString() + ':' + (m === 0 ? '00' : m.toString()) + 'Hrs';
  }

}
